import { GetHolidaysQueryReq, HolidayResponse, HolidayUpsertRequest } from "../../interfaces";
import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { apiGet, apiDelete, apiPut, apiPost } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";

export async function GetAllHolidaysAsync(
    authToken: string,
    payload: GetHolidaysQueryReq
): Promise<ApiResponse<PagedResults<HolidayResponse>>> {
    const queryString = buildQuery(payload);
    const apiUrl: string = `/holidays/getholiday?${queryString}`;

    var res = apiGet<ApiResponse<PagedResults<HolidayResponse>>>(
        apiUrl, authToken
    );

    return res;
}


export async function SaveHolidayAsync(
    authToken: string,
    payload: HolidayUpsertRequest
): Promise<ApiResponse<HolidayUpsertRequest>> {
    const apiUrl: string = `/holidays/createholiday`;

    var res = apiPost<ApiResponse<HolidayUpsertRequest>>(
        apiUrl, payload, authToken
    );

    return res;
}

export async function UpdateHolidayAsync(
    authToken: string,
    holidayId : number,
    payload: HolidayUpsertRequest
): Promise<ApiResponse<HolidayResponse>> {
    const apiUrl: string = `/holidays/updateholiday/${holidayId}`;

    var res = apiPut<ApiResponse<HolidayResponse>>(
        apiUrl, payload, authToken
    );

    return res;
}
export async function DeleteHolidayAsync(
    authToken: string,
    holidayId : number,
): Promise<ApiResponse<HolidayResponse>> {
    const apiUrl: string = `/holidays/deleteholiday/${holidayId}`;

    var res = apiDelete<ApiResponse<HolidayResponse>>(
        apiUrl, null, authToken
    );

    return res;
}
